'use client';

import { useEffect } from 'react';
import { ChannelIOFn } from "@/types/channelTalk";
import { usePathname } from 'next/navigation';

const ChannelTalkScript = () => {
    const pathname = usePathname();

    useEffect(() => {
        (function () {
            const w = window;

            if (w.ChannelIO) {
                w.console.error("ChannelIO script included twice.");
                return;
            }

            const ch = function (...args: unknown[]) {
                ch.c(args);
            } as ChannelIOFn;

            ch.q = [];
            ch.c = function (args: unknown[]) {
                ch.q.push(args);
            };

            w.ChannelIO = ch;

            function l() {
                if (w.ChannelIOInitialized) {
                    return;
                }
                w.ChannelIOInitialized = true;
                const s = document.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
                const x = document.getElementsByTagName("script")[0];
                if (x.parentNode) {
                    x.parentNode.insertBefore(s, x);
                }
            }

            if (document.readyState === "complete") {
                l();
            } else {
                w.addEventListener("DOMContentLoaded", l);
                w.addEventListener("load", l);
            }
        })();

        window.ChannelIO?.("boot", {
            pluginKey: process.env.NEXT_PUBLIC_CHANNEL_PLUGIN_KEY,
            zIndex: 1999,
        });
    }, []);

    // // 페이지 변경 시 setPage 호출

    useEffect(() => {
        if (typeof window !== 'undefined' && window.ChannelIO) {
            const currentUrl = window.location.origin + pathname;
            window.ChannelIO('setPage', currentUrl);
        }
    }, [pathname]);

    return null; // UI를 렌더링하지 않음
};

export default ChannelTalkScript;